module.exports = __webpack_public_path__ + "static/media/staff-training.77a4f601.svg";